<template>
  <div>
    <div class="m-subheader">
      <div class="mr-subheader-box">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <span class="subheader-icon">
              <i class="m-menu__link-icon flaticon-line-graph"></i>
            </span>
            <h3 class="m-subheader__title">Masraf Tipi</h3>
          </div>
          <div>
           
          </div>
        </div>
      </div>
    </div>

    <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <!--begin::Portlet-->
          <div class="m-portlet">
            <div class="m-portlet__head">
              <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                  <span class="m-portlet__head-icon m--hide">
                    <i class="la la-gear"></i>
                  </span>
                  <h3 class="m-portlet__head-text">
                    <a
                      :href="'#/expensetype'"
                      class="btn btn-sm btn-secondary m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill m--margin-right-10"
                    >
                      <i class="la la-angle-left"></i>
                    </a>
                    Masraf Tipi Ekle
                  </h3>
                </div>
              </div>
            </div>

            <!--begin::Form-->
            <form class="m-form m-form--fit m-form--label-align-right">
              <div class="m-portlet__body m-form-box-cont">
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Masraf Tipi Kodu</label>
                    <input type="text"  :class="{ 'is-invalid': $v.expensetype.code.$error }" v-model="expensetype.code" class="form-control m-input" placeholder="Masraf tipi kodunu giriniz." />
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Masraf Tipi Adı</label>
                    <input type="text"  :class="{ 'is-invalid': $v.expensetype.name.$error }" v-model="expensetype.name" class="form-control m-input" placeholder="Masraf tipi adı giriniz." />
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Açıklama</label>
                    <textarea  :class="{ 'is-invalid': $v.expensetype.description.$error }" class="form-control m-input" v-model="expensetype.description" placeholder="Masraf tipi açıklamasını giriniz." id="exampleTextarea" rows="3"></textarea>
                  </div>
                </div>
              </div>
              <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                <div class="m-form__actions m-form__actions--solid">
                  <div class="row">
                    <div class="col-lg-12">
                      <button type="button" @click="expensetype.id==0?create():update()" class="spbtn">Kaydet</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            <!--end::Form-->
          </div>

          <!--end::Portlet-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import {_create,_getById,_update} from '../../services/ExpenseTypeService'

export default {
created() {
  if(Number(this.$route.params.id)!=0)
        {
          this.expensetype.id=Number(this.$route.params.id);
              this.getById();
        }
},

  data() {
    return {
      expensetype:{
        id:0,
        code:'',
        description:'',
        name:''
      }
    }
  },
    validations: {
    expensetype: {
      code: { required },
           description: { required },
            name: { required }
    }
  },
methods: {
  create:function(){
          this.$v.expensetype.$touch();
      if (this.$v.expensetype.$error) return;
          // let loader=this.$loading.show();
    _create(this.expensetype).then(response=>{
      // loader.hide();
      if(response.data.success)
        this.$router.push({ name: 'expenseTypes' })
    });
  },
  update:function(){
          this.$v.expensetype.$touch();
      if (this.$v.expensetype.$error) return;
    _update(this.expensetype).then(response=>{
      if(response.data.success)
        this.$router.push({ name: 'expenseTypes' })
    });
  },
  getById:function(){
    _getById(Number(this.$route.params.id)).then(response=>{
      if(response.data.success)
      this.expensetype=response.data.data;
      else
      this.$router.push({ name: 'expenseTypes' })
    })
  }
},
};
</script>